export default __webpack_public_path__ + "static/media/espa1.84fc2539.png";